






import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

import SettingController from "./settingController/settingController.vue";

@Component({
    components: {
        SettingController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class PopupController extends Vue 
{
    @Prop() borderColor! : ColorConstruct;
    @Prop() controllerType! : string;

    private onDoCommand(command: string, parameter: any)
    {
        this.$emit("doCommand", command, parameter);
    }
}
